import { format } from 'date-fns';
import { useCallback, useContext, useState } from 'react';
import _ from 'lodash';
import { unstable_batchedUpdates } from 'react-dom';
import { AuthContext } from 'routes/auth.context';
import { IRetrieverV2 } from './index.types';
// { dataKeyName: 'dataPedido' }
export const usePaginationAndFilterV2 = (
    props = { dataKeyName: null, keysQueryVariavel: [], onSearchComplete: null, onScrollInfinite: null }
): IRetrieverV2 => {
    const { cacheFiltroData } = useContext(AuthContext);
    const [pagina, setPagina] = useState(1);
    const [meta, setMeta] = useState({} as any);
    const [loading, setLoading] = useState(true);
    const [hasMore, setHasMore] = useState(false);
    const [filter, setFilter] = useState({
        ...(props.dataKeyName
            ? { [props.dataKeyName]: format(cacheFiltroData, 'yyyy-MM-dd') }
            : {}),
    });

    const [response, setResponse] = useState([]);

    const handleSetResponse = useCallback((data) => {
        setResponse(data);
    }, []);
    const unionList = useCallback(
        (prev, next, resetPageZero = true) => {
            if (pagina === 1 && resetPageZero) return next;
            const prevIds = {};
            prev.forEach(({ id }, key) => (prevIds[id] = key));
            let clone = [...prev];
            next.forEach(({ id, ...rest }) => {
                if (prevIds[id] >= 0) {
                    clone[prevIds[id]] = { id, ...clone[prevIds[id]], ...rest };
                } else {
                    clone.push({ id, ...rest });
                }
            });
            return clone;
        },
        [pagina]
    );
    const onSubscriptionData = useCallback(
        (data, transformData = undefined) => {
            if (data && data.id) {
                setResponse((prev) => {
                    return transformData
                        ? transformData({ prevList: prev, nextChild: data })
                        : unionList(prev, [data], false);
                });
            }
        },
        [pagina]
    );

    const onCompleted = useCallback(
        (data, hasUnion = true) => {
            unstable_batchedUpdates(() => {
                setHasMore((data.data && data.meta.nextPage) || false);
                setResponse((prev) =>
                    hasUnion
                        ? unionList(prev, data.data)
                        : (data && data.data) || []
                );
                setMeta(data.meta || {});
            });
        },
        [pagina]
    );

    const handleSearch = useCallback((data: any = {}) => {
        const clone = { ...data };
        if (clone && clone.dataSelecionada) {
            if (props.dataKeyName) {
                clone[props.dataKeyName] =
                    typeof clone.dataSelecionada === 'string'
                        ? clone.dataSelecionada
                        : format(clone.dataSelecionada, 'yyyy-MM-dd');
            }

            delete clone.dataSelecionada;
        }
        const result = Object.fromEntries(
            Object.entries(clone).filter(
                ([key, value]) =>
                    [...props.keysQueryVariavel].includes(key) && !!value
            )
        );

        setFilter(
            result as {
                [k: string]: string;
            }
        );
        setPagina(1);
        if(props.onSearchComplete)
            props.onSearchComplete(result);
    }, []);

    const onError = useCallback((err) => {
        console.error(err);
    }, []);

    const onPagination: any = useCallback(() => {
        if (!loading && hasMore) {
            setPagina((prev) => prev + 1);
            props.onScrollInfinite && props.onScrollInfinite(pagina + 1);
        }
    }, [loading, hasMore]);

    return {
        setLoading,
        loading,
        onError,
        onPagination,
        response,
        hasMore,
        handleSearch,
        variables: { filter },
        handleSetResponse,
        onSubscriptionData,
        onCompleted,
        pagina,
        total: meta.total,
        meta,
        context: {
            headers: {
                'current-page': `${pagina}`,
            },
        },
    };
};
